<script setup lang="ts">
import { selectClasses } from './variants'

defineProps<{
  isSelected: boolean
}>()
const emit = defineEmits<{
  toggle: []
}>()
</script>

<template>
  <div
    :class="selectClasses.menuButton"
    role="option"
    data-reka-vue-collection-item
    tabindex="-1"
    :aria-selected="isSelected"
    @click="emit('toggle')"
    @mouseenter="(e) => (e.target as HTMLElement)?.focus()"
    @keydown.enter="emit('toggle')"
    @keydown.space="emit('toggle')"
  >
    <span
      v-if="isSelected"
      :class="selectClasses.menuButtonIconContainer"
      aria-hidden
    >
      <UiIcon
        name="docue:check"
        :class="selectClasses.menuButtonIcon"
      />
    </span>

    <slot />
  </div>
</template>
